"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappedColumnGrid = exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ColumnGrid = function ColumnGrid(_ref) {
  var children = _ref.children,
      classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.ColumnGrid
  }, children);
};

ColumnGrid.propTypes = {
  children: _propTypes["default"].any,
  classes: _propTypes["default"].object
};
var ThemedColumnGrid = (0, _ThemeProvider.withStyles)((0, _style["default"])())(ColumnGrid);
exports["default"] = ThemedColumnGrid;

var generateColumnComponent = function generateColumnComponent(minimalWidth, columnsCount) {
  var baseStyle = (0, _style["default"])(minimalWidth, columnsCount)();
  var nested = (0, _immutable.fromJS)(baseStyle);
  var extStyle = nested.mergeDeep({
    ColumnGrid: baseStyle.WrappedColumnGrid
  }).toJS();
  return (0, _ThemeProvider.withStyles)(function () {
    return extStyle;
  })(ColumnGrid);
};

var WrappedColumnGrid = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(WrappedColumnGrid, _React$Component);

  var _super = _createSuper(WrappedColumnGrid);

  function WrappedColumnGrid() {
    var _this;

    (0, _classCallCheck2["default"])(this, WrappedColumnGrid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      minimalWidth: _this.props.minimalWidth,
      column: generateColumnComponent(_this.props.minimalWidth, _this.props.children.length)
    });
    return _this;
  }

  (0, _createClass2["default"])(WrappedColumnGrid, [{
    key: "componentWillReciveProps",
    value: function componentWillReciveProps(props) {
      if (props.minimalWidth !== this.state.minimalWidth) {
        this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
          minimalWidth: props.minimalWidth,
          column: generateColumnComponent(props.minimalWidth, props.children.length)
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var SmartColumn = this.state.column;
      return /*#__PURE__*/_react["default"].createElement(SmartColumn, null, this.props.children);
    }
  }]);
  return WrappedColumnGrid;
}(_react["default"].Component);

exports.WrappedColumnGrid = WrappedColumnGrid;
(0, _defineProperty2["default"])(WrappedColumnGrid, "propTypes", {
  children: _propTypes["default"].any,
  minimalWidth: _propTypes["default"].number.isRequired
});
//# sourceMappingURL=ColumnGrid.js.map